


import React, { useState } from 'react';
import blurTop from '../../assets/splashScreen/Blur.svg'
import address from '../../assets/splashScreen/Group 715.svg'
import { useNavigate } from 'react-router-dom';


export default function KYCVerificationAddressForm({ onKycSubmit }) {

    const navigate = useNavigate()
    const [addressData, setAddressData] = useState({
        street: '775 Rolling Green Rd.',
        city: 'Pembroke Pines',
        lga: 'name@email.com',
        state: 'Mexico City',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddressData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Address Data Submitted:", addressData);
        // Simulate submission success
        // onKycSubmit(); // Assuming this moves to the next step
        document.getElementById('kyc-message').textContent = "Address data submitted successfully!";
        setTimeout(() => {
            document.getElementById('kyc-message').textContent = "";
            // Optional: Call parent function to move to next screen
            if (onKycSubmit) onKycSubmit();
        }, 1500);
    };

    return (
        <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden">

            {/* Decorative Blur Background */}
            <img
                src={blurTop}
                alt="Decorative background blur"
                className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-50 max-h-48 object-cover"
            />

            {/* Content Area */}
            <div className="relative z-10 w-full max-w-sm mx-auto">

                {/* Illustration */}
                <div className="flex-1 flex justify-center items-center mt-4">
                    <img
                        src={address}
                        alt=""
                        className="w-full max-w-xs max-h-[45vh] object-contain"
                    />
                </div>

                {/* Header Text */}
                <h1 className="text-3xl font-bold text-gray-900 mt-2">Address</h1>

                <p className="text-gray-600 text-sm mt-1 mb-8">
                    Please submit the following documents verify your profile.
                </p>

                {/* Custom Message Box */}
                <div id="kyc-message" className="mb-4 text-center text-sm font-semibold text-green-600 h-6"></div>

                <form className="space-y-6" onSubmit={handleSubmit}>

                    {/* Street Input */}
                    <div>
                        <label htmlFor="street" className="text-gray-700 text-base font-medium block mb-1">
                            Street
                        </label>
                        <input
                            id="street"
                            name="street"
                            type="text"
                            placeholder="775 Rolling Green Rd."
                            value={addressData.street}
                            onChange={handleChange}
                            className="w-full px-4 py-3 rounded-xl bg-gray-100 text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-800 shadow-inner"
                            required
                        />
                    </div>

                    {/* City Dropdown */}
                    <div>
                        <label htmlFor="city" className="text-gray-700 text-base font-medium block mb-1">
                            City
                        </label>
                        <div className="relative">
                            <select
                                id="city"
                                name="city"
                                value={addressData.city}
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-xl appearance-none bg-gray-100 text-gray-800 border border-gray-300 focus:border-blue-500 outline-none shadow-inner cursor-pointer"
                                required
                            >
                                {/* Options to match the placeholder look */}
                                <option value="Pembroke Pines">Pembroke Pines</option>
                                <option value="Miami">Miami</option>
                                <option value="New York">New York</option>
                            </select>
                            {/* Custom Dropdown Arrow */}
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-700">
                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div>
                        </div>
                    </div>

                    {/* LGA Input (matching the "name@email.com" placeholder) */}
                    <div>
                        <label htmlFor="lga" className="text-gray-700 text-base font-medium block mb-1">
                            LGA
                        </label>
                        <input
                            id="lga"
                            name="lga"
                            type="text"
                            placeholder="name@email.com"
                            value={addressData.lga}
                            onChange={handleChange}
                            className="w-full px-4 py-3 rounded-xl bg-gray-100 text-gray-800 border border-gray-300 focus:border-blue-500 outline-none placeholder:text-gray-400 shadow-inner"
                            required
                        />
                    </div>

                    {/* State Dropdown */}
                    <div>
                        <label htmlFor="state" className="text-gray-700 text-base font-medium block mb-1">
                            State
                        </label>
                        <div className="relative">
                            <select
                                id="state"
                                name="state"
                                value={addressData.state}
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-xl appearance-none bg-gray-100 text-gray-800 border border-gray-300 focus:border-blue-500 outline-none shadow-inner cursor-pointer"
                                required
                            >
                                {/* Options to match the placeholder look */}
                                <option value="Mexico City">Mexico City</option>
                                <option value="California">California</option>
                                <option value="Florida">Florida</option>
                            </select>
                            {/* Custom Dropdown Arrow */}
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-700">
                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit" onClick={() => {
                            navigate('/kycid')
                        }}
                        className="w-full bg-blue-600 py-4 rounded-xl text-white mt-10 font-semibold shadow-xl hover:bg-blue-700 transition-colors flex items-center justify-center"
                    >
                        Next
                    </button>
                </form>
            </div>
        </div>
    );
}